import { FieldError } from 'react-hook-form';
import styles from './error-field.module.css';
import { useTranslation } from '@/contexts/i18n-context';
import clsx from 'clsx';

interface FieldErrorProps {
  error?: FieldError;
  className?: string;
}

export function ErrorField({ error, className }: FieldErrorProps) {
  const { t, isTranslationKey } = useTranslation();

  if (!error) return null;

  const errorMessage =
    error.message && isTranslationKey(error.message) ? t(error.message) : error.message;

  return <span className={clsx('caption', styles.errorMessage, className)}>{errorMessage}</span>;
}
